<template>
    <v-container>
        <v-divider></v-divider>
        <v-row >
            <v-col class="mx-10" cols="2">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="เดือนที่แสดงข้อมูล"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        type="month"
                        no-title
                        :show-current="false"
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col>
                <v-select
                    small-chips
                    chips
                    placeholder="เลือกกลุ่มของสมาชิก"
                    label="กลุ่ม"
                    multiple
                    :items="groups">
                </v-select>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row>
            <v-col class="mx-10">
                <v-data-table
                :headers="headers"
                :items="desserts"
                :items-per-page="10"
                class="elevation-1"
            >
                <template v-slot:footer>
                    <v-divider></v-divider>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col>
                            สมาชิกที่เปลี่ยนแปลงประจำเดือน {{date}}  <b> : 178 คน</b>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
            </v-col>
            
        </v-row>
          
    </v-container>
  
</template>


<script>
import Constant from '@/model/utils/Constants.js'
export default {
    name: "ReportMember",
    data: () => ({
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        groups: Constant.groups,
        headers: [
            {text: 'วันที่', value: 'date'},
            {text: 'จำนวนสมาชิกที่นำเข้า', value: 'col1'},
            {text: 'จำนวนเปลี่ยนแปลง', value: 'col2'},
            {text: 'จำนวนสมาชิกทั้งหมด', value: 'col3'},
            ],
        desserts: [
            {'date': '01/01/2021',
             'col1': 0, 'col2': 0, 'col3':  0
            },
            {'date': '02/01/2021',
             'col1': 3, 'col2': 3, 'col3':  3
            },
            {'date': '03/01/2021',
             'col1': 46, 'col2': 43, 'col3':  49
            },
            {'date': '04/01/2021',
             'col1': 55, 'col2': 9, 'col3':  104
            },
            {'date': '05/01/2021',
             'col1': 30, 'col2': -25, 'col3':  134
            },
            {'date': '06/01/2021',
             'col1': 44, 'col2': 14, 'col3':  178
            },
            {'date': '07/01/2021',
             'col1': 0, 'col2': -44, 'col3':  178
            },
            {'date': 'รวม',
             'col1': 178, 'col2': 0, 'col3':  178
            },
        ]
    })
}
</script>